import { render } from "./IconBadge.vue?vue&type=template&id=5e86cedc"
import script from "./IconBadge.vue?vue&type=script&lang=js"
export * from "./IconBadge.vue?vue&type=script&lang=js"

import "./IconBadge.vue?vue&type=style&index=0&id=5e86cedc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__